import React from 'react';
import PropTypes from 'prop-types';

const LandingContent = ({
  title,
  description,
  action,
  actionButtonTitle,
  heroImage,
  className,
}) => {
  return (
    <div className={`landing-page ${className}`}>
      <section className="landing-page__section--img">
        <img
          className="landing-page__image"
          src={heroImage}
          alt="Landing Hero"
        />
      </section>
      <header>{title}</header>
      <p className="landing-page__section--content">
        {description}
      </p>
      {actionButtonTitle && (
        <section className="landing-page__section--buttons">
          <button
            className="button--landing"
            onClick={() => action()}
          >
            {actionButtonTitle}
          </button>
        </section>
      )}
    </div>
  );
};

LandingContent.propTypes = {
  action: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.node,
  actionButtonTitle: PropTypes.string,
  heroImage: PropTypes.string,
};

LandingContent.defaultProps = {
  action: () => {},
  title: '',
  description: '',
  actionButtonTitle: 'Start',
  heroImage: '',
};

export default LandingContent;
